<nz-layout>
  <nz-header nz-row nzJustify="space-between">
    <div nz-col nzFlex="auto">
      <nz-space>
        @if (fromRoute) {
          <button *nzSpaceItem nz-button nzType="default" (click)="back()">
            <i nz-icon nzType="left" nzTheme="outline"></i> {{'calendar.calendarTitle' | translate}}
          </button>
        }
        <button *nzSpaceItem nz-button nzType="default" (click)="currenDate()"><i nz-icon nzType="carry-out" nzTheme="outline"></i>
      </button>
      <beautyapp-datepicker *nzSpaceItem style="margin-top: 16px;" [(ngModel)]="currentDate" (ngModelChange)="changeDate($event)"
      [allowClear]="false"></beautyapp-datepicker>
    </nz-space>
  </div>

  <div nz-col nzFlex="initial">
    <nz-space>
      <!-- beaut-365: day-form slot granularity selector -->
      <nz-space-compact *nzSpaceItem>
        <button
          nz-button
          [nzType]="timeInterval === '00:05:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:05:00')"
        >5 {{ 'calendar.minute' | translate }}.</button>
        <button
          nz-button
          [nzType]="timeInterval === '00:15:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:15:00')"
        >15 {{ 'calendar.minute' | translate }}.</button>
        <button
          nz-button
          [nzType]="timeInterval === '00:20:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:20:00')"
        >20 {{ 'calendar.minute' | translate }}.</button>
        <button
          nz-button
          [nzType]="timeInterval === '00:30:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:30:00')"
        >30 {{ 'calendar.minute' | translate }}.</button>
        <button
          nz-button
          [nzType]="timeInterval === '01:00:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('01:00:00')"
        >1{{ 'calendar.hours' | translate }}.</button>
      </nz-space-compact>
      <nz-space-compact *nzSpaceItem>
        <button nz-button nzType="primary" (click)="dayGridChange('timeGrid')">1 {{'calendar.day' | translate}}</button>
        <button nz-button nzType="primary" (click)="dayGridChange('timeGridSevenDays')">7 {{'calendar.day' | translate}}</button>
      </nz-space-compact>
    </nz-space>
  </div>
</nz-header>
<nz-content>
  <full-calendar #calendar [options]="calendarOptions">
    <ng-template #eventContent let-event>
      <ng-template #popContent>
        <div class="booking-popup">
          <div><b>{{ 'calendar.popup.employee' | translate }}:</b> {{ event.event.extendedProps.employeeName }}</div>
          @if (event.event.extendedProps?.roomName) {
            <div><b>ოთახი:</b> {{ event.event.extendedProps.roomName }}</div>
          }
          @if (event.event.extendedProps.source) {
            <div><b>{{ 'calendar.popup.source' | translate }}:</b> {{ event.event.extendedProps.source.name }}</div>
          }
          @if (event.event.extendedProps.anonymousName || event.event.extendedProps.fullName) {
            <div><b>{{ 'calendar.popup.user' | translate }}:</b> {{ event.event.extendedProps.isAnonymous ? event.event.extendedProps.anonymousName : event.event.extendedProps.fullName }}</div>
          }
          @if (event.event.extendedProps.mobilePhone) {
            <div><b>{{ 'calendar.popup.mobilePhone' | translate }}:</b> {{ event.event.extendedProps.mobilePhone }}</div>
          }
          @if (event.event.extendedProps.balance) {
            <div><b>{{ 'calendar.popup.balance' | translate }}:</b> {{ event.event.extendedProps.balance }} GEL</div>
          }
          @if (event.event.extendedProps.services) {
            <div><b>{{ 'calendar.popup.procedure' | translate }}:</b> {{ event.event.extendedProps.services }}</div>
          }
          @if (event.event.extendedProps.price) {
            @if (event.event.extendedProps.salePrice) {
              <div><b>{{ 'calendar.popup.price' | translate }}:</b>
                <del>{{ event.event.extendedProps.price }} GEL</del>
              </div>
            } @else {
              <div><b>{{ 'calendar.popup.price' | translate }}:</b> {{ event.event.extendedProps.price }} GEL</div>
            }
          }
          @if (event.event.extendedProps.salePrice) {
            <div><b>{{ 'calendar.popup.discount' | translate }}:</b> {{ event.event.extendedProps.salePrice }} GEL</div>
          }
          @if (event.event.extendedProps.visitStatus) {
            <div><b>{{ 'calendar.popup.status' | translate }}:</b> {{ event.event.extendedProps.visitStatus | visitStatus }}</div>
          }
          <div><b>{{ 'calendar.popup.times' | translate }}:</b> {{ (event.event.start | date : 'HH:mm') + ' - ' + (event.event.end | date : 'HH:mm') }}</div>
          @if (event.event.extendedProps.latestComment?.text || event.event.extendedProps.description) {
            <div class="flex items-center gap-1">
              <b>{{ 'calendar.popup.comment' | translate }}:</b>
              @if (event.event.extendedProps.latestComment?.isPinned) {
                <i nz-icon nzType="pushpin" nzTheme="fill" style="color: #1890ff;"></i>
              }
              {{ event.event.extendedProps.latestComment?.text || event.event.extendedProps.description }}
              @if (event.event.extendedProps.commentCount > 0) {
                <span class="text-xs text-gray-400">({{ event.event.extendedProps.commentCount }})</span>
              }
            </div>
          }
          @if (event.event.extendedProps.createdAt) {
            <div><b>{{ 'calendar.popup.bookedAt' | translate }}:</b> {{ event.event.extendedProps.createdAt | date: 'dd/MM/yyyy HH:mm' }}</div>
          }
          @if (event.event.extendedProps.createdBy) {
            <div><b>{{ 'calendar.popup.bookedBy' | translate }}:</b> {{ event.event.extendedProps.createdBy }}</div>
          }
          @if (event.event.extendedProps.completedBy) {
            <div><b>{{ 'calendar.popup.completedBy' | translate }}:</b> {{ event.event.extendedProps.completedBy }}</div>
          }
        </div>
      </ng-template>
      <div class="fc-event-title"
           nz-popover
           [nzPopoverTitle]="(event.event.extendedProps.bookingDate | date:'dd/MM/yyyy') +' - '+(event.event.start | date : 'HH:mm') + '-' + (event.event.end | date : 'HH:mm')"
           [nzPopoverContent]="popContent"
           nzPopoverPlacement="topLeft"
      >
        <div class="fc-event-title__name">
          @if (event.event?.extendedProps?.roomName) {
            <span
              nz-icon
              nzType="home"
              nzTheme="outline"
              [nzTooltipTitle]="event.event?.extendedProps?.roomName"
              nz-tooltip
            ></span>
          }
          @if (event.event?.extendedProps.onlineBookingId) {
            <span nz-icon nzType="global" nzTheme="outline"></span>
          }
          @if (event.event?.extendedProps.visitStatus) {
            @switch (event.event.extendedProps.visitStatus) {
              @case ('CONFIRMED') {
                <span nz-icon nzType="check-circle" nzTheme="outline" nz-tooltip="დასტურებული"></span>
              }
              @case ('IN_PROGRESS') {
                <span nz-icon nzType="clock-circle" nzTheme="outline" nz-tooltip="პროცესში"></span>
              }
              @case ('COMPLETED') {
                <span nz-icon nzType="lock" nzTheme="fill" nz-tooltip="დასრულებული"></span>
              }
              @case ('NO_SHOW') {
                <span nz-icon nzType="user-delete" nzTheme="outline" nz-tooltip="არ გამოცხადდა"></span>
              }
              @case ('NEED_CALL') {
                <span nz-icon nzType="phone" nzTheme="outline" nz-tooltip="დასარეკია"></span>
              }
            }
          } @else if (event.event?.extendedProps.status === 2) {
            <span nz-icon nzType="lock" nzTheme="fill"></span>
          }
          @if (event.event?.extendedProps?.onUserRequest) {
            <span nz-icon nzType="star" nzTheme="fill"></span>
          }
          @if (event.event?.extendedProps?.source) {
            @if (isEmoji(event.event?.extendedProps?.source?.icon)) {
              <span class="text-sm">{{ event.event?.extendedProps?.source?.icon }}</span>
            } @else if (event.event?.extendedProps?.source?.icon) {
              <span nz-icon [nzType]="event.event?.extendedProps?.source?.icon" nzTheme="outline"></span>
            }
          }
          <span>
            {{ event.event?.title }}
            {{ event.event?.extendedProps?.mobilePhone }}
          </span>
        </div>
      </div>
    </ng-template>
  </full-calendar>
</nz-content>
</nz-layout>
